<script setup lang="ts">
import {onMounted, ref, useTemplateRef} from "vue";
import {type} from "jquery";

const props = withDefaults(
  defineProps<{
    type: "text"|"email"|"number",
    value: string,
    required: boolean,
    minlength?: number,
    maxlength?: number,
    min?: number,
    max?: number,
    step?: number,
    pattern?: string,
    customValidator?: (value: string) => string,
  }>(),
  {
    type: "text",
    required: false,
  },
);
const input = useTemplateRef<HTMLInputElement>('input');

onMounted(() => {
  if (typeof props.customValidator !== "undefined") {
    input.value?.setCustomValidity(props.customValidator(props.value))
  }
})
</script>

<template>
  <input
      ref="input"
      :value="props.value"
      :type="props.type"
      :required="props.required"
      :minlength="props.minlength"
      :maxlength="props.maxlength"
      :min="props.min"
      :max="props.max"
      :step="props.step"
      :pattern="props.pattern"
  >
</template>

<style scoped lang="scss">
input {
  width: 1px;
  height: 1px;
  border: none;
  pointer-events: none;
  opacity: 0;
  outline: none;

  &:hover,
  &:focus,
  &:active {
    border: none;
    outline: none;
  }
}
</style>